import Vue from 'vue'
import Router from 'vue-router'
import Maze from '@/pages/Maze'
import Puzzle from '@/pages/Puzzle'
import Poker from '@/pages/Poker'
import LuckyWheel from '@/pages/LuckyWheel'
import LuckyGrid from '@/pages/LuckyGrid'
import LuckyEgg from '@/pages/LuckyEgg'
import LuckyPoints from '@/pages/LuckyPoints'
import ScratchCard from '@/pages/ScratchCard'
import QuestionChallenge from '@/pages/QuestionChallenge'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/maze/:id/:type?',
      name: 'Maze',
      component: Maze,
    },
    {
      path: '/puzzle/:id/:relateId?',
      name: 'Puzzle',
      component: Puzzle,
    },
    {
      path: '/poker/:id/:relateId?',
      name: 'Poker',
      component: Poker,
    },
    {
      path: '/luckywheel/:id',
      name: 'LuckyWheel',
      component: LuckyWheel,
    },
    {
      path: '/luckygrid/:id',
      name: 'LuckyGrid',
      component: LuckyGrid,
    },
    {
      path: '/luckyegg/:id',
      name: 'LuckyEgg',
      component: LuckyEgg,
    },
    {
      path: '/luckypoints/:id',
      name: 'LuckyPoints',
      component: LuckyPoints,
    },
    {
      path: '/scratchcard/:id',
      name: 'ScratchCard',
      component: ScratchCard,
    },
    {
      path: '/queschallenge/:id',
      name: 'QuestionChallenge',
      component: QuestionChallenge,
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js